import { data } from '../../constants/Constants';
import device from '../../utilitarios/device';


export function getDevice() {
       return localStorage.getItem("mc");
       // return "4CDDACD4-31D3-427F-86D5-D8C445718B48";
}

